'use es6';

import { createFetchImportNamesByObjectType, fetchImportNamesByObjectType } from '../api/ImportsAPI';
import * as CacheKeys from '../constants/CacheKeys';
import createSimpleCachedReferenceResolver from '../lib/createSimpleCachedReferenceResolver';
export const createInboundDbDealImportReferenceResolver = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.INBOUND_DB_DEAL_IMPORT,
  createFetchData: opts => {
    const getFn = createFetchImportNamesByObjectType(opts);
    return () => getFn('deal');
  },
  fetchData: () => fetchImportNamesByObjectType('deal')
}, options));
export default createInboundDbDealImportReferenceResolver();